import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Cover } from '../../components/primitives/Cover';
import { SocialChannelConnection } from '../types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelConnectionIdentityProps {
  connection: SocialChannelConnection;
  /** The channel is connected through the sign-in of Instagram itself, not through a Facebook Page. */
  signedInWithInstagram?: boolean;
}

/** Who the login connected: the page, channel or account the posts go to. */
const ChannelConnectionIdentityComponent: React.FC<ChannelConnectionIdentityProps> = ({
  connection,
  signedInWithInstagram = false,
}) => {
  const intl = useIntl();
  const name =
    connection.displayName ??
    intl.formatMessage({ id: 'app.sml.promote.channel.connection.unnamed', defaultMessage: 'Connected account' });

  return (
    <div className={styles.identity}>
      <Cover src={connection.avatarUrl} label={name} size={32} radius="50%" />
      <div className={styles.identityBody}>
        <div className={styles.identityName}>{name}</div>
        {/* Support reads this line to tell the two logins of Instagram apart. The Page login has no line. */}
        {signedInWithInstagram ? (
          <span className={styles.identityNote}>
            {intl.formatMessage({
              id: 'app.sml.promote.channels.instagramLogin.signedIn',
              defaultMessage: 'Signed in with Instagram',
            })}
          </span>
        ) : null}
        {connection.profileUrl === null ? null : (
          <a className={styles.identityLink} href={connection.profileUrl} target="_blank" rel="noreferrer">
            {intl.formatMessage({
              id: 'app.sml.promote.channel.connection.openProfile',
              defaultMessage: 'Open the profile',
            })}
          </a>
        )}
      </div>
    </div>
  );
};

export const ChannelConnectionIdentity = TypedMemo(ChannelConnectionIdentityComponent);
